/* eslint-disable @typescript-eslint/no-explicit-any */
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { Button } from "@/components/ui/button";
import { typeCheck } from "@/lib/type-check";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import JsonView from "@uiw/react-json-view";
import { cn } from "@/lib/utils";

export const DocumentErpLogPopup = ({ /* open, */ setOpen, data }: any) => {
  const AVOID = [
    "cts",
    "uts",
    // "unique_id",
    // "erp_job_id",
    "request",
    "response",
  ];
  return createPortal(
    <div className="fixed left-0 top-0 w-full h-full z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-md w-[90%] h-[90%] overflow-hidden">
        <div className="flex justify-between px-5 items-center py-3 border">
          <h3>ERP Log</h3>
          <Button
            size={"icon"}
            variant={"outline"}
            className={"text-red-500"}
            onClick={() => setOpen(false)}
          >
            <X />
          </Button>
        </div>
        <div className="scrollbar max-h-[90%] overflow-auto px-5 my-5">
          <table className="w-full">
            <thead>
              <tr>
                {AVOID.map((item: any, cellIndex: number) => {
                  return (
                    <td
                      key={cellIndex}
                      className={cn(
                        "text-left bg-gray-100 px-2 py-2 text-xs capitalize font-fw-semibold border border-transparent sticky top-0 z-[2]",
                        {
                          "w-[200px]": ["cts", "uts"].includes(item),
                          "w-[calc(50%_-_200px)]": !["cts", "uts"].includes(
                            item
                          ),
                        }
                      )}
                    >
                      <SwitchRenderer
                        type={item}
                        components={{
                          cts: "Created on",
                          uts: "Updated on",
                          default: item,
                        }}
                      />
                    </td>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={4}>
                    <div className="flex items-center justify-center h-[400px] text-slate-500 text-2xl">
                      Record not found
                    </div>
                  </td>
                </tr>
              ) : null}
              {data?.map((item: any, rowIndex: number) => {
                return (
                  <tr key={rowIndex}>
                    {AVOID.map((cell: any, cellIndex: number) => {
                      const type = typeCheck(item[cell]);
                      return (
                        <td
                          key={cellIndex}
                          className="text-left px-2 py-2 text-xs border border-transparent align-top"
                        >
                          <SwitchRenderer
                            type={type}
                            components={{
                              String: item[cell], // Maps both "success" and "winner" to Success
                              Object: (
                                <JsonView
                                  defaultChecked={false}
                                  value={item[cell]}
                                  keyName="json"
                                  enableClipboard={true}
                                  collapsed={true}
                                  displayDataTypes={false}
                                />
                              ),
                            }}
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>,
    document.body
  );
};
